module.exports = __webpack_public_path__ + "static/media/fermer-cercle.b8483556.png";